(function () {
    'use strict';

    angular
        .module('app')
        .factory('selectionCommandService', selectionCommandService);

    //2018 SP1 Refactor: 20180828 - GT
    //inject extractionservice to call updateextractiondata, clearextracteddata and getplugindefinitions
    selectionCommandService.$inject = ['$rootScope', '$mdDialog', '$localStorage', 'optionsService', '$state', '$q', 'loginService', 'gridDataService', '$window', '$http', '$filter'];

    function selectionCommandService($rootScope, $mdDialog, $localStorage, optionsService, $state, $q, loginService, gridDataService, $window, $http, $filter) {

        var service = {
            fileNewSettings: {},
            ExToErr: ExToErr,
            ShowEx: ShowEx,
            CheckOutVaultCheck: CheckOutVaultCheck,
            CheckOutItem: CheckOutItem,
            PreCheckInItem: PreCheckInItem,
            CheckInItem: CheckInItem,
            getFileTypes: getFileTypes,
            newDoc: newDoc,
            ReleaseCheckOut: ReleaseCheckOut,
            AcquireCheckOutSources: AcquireCheckOutSources,
            AcquireCheckOut: AcquireCheckOut,
            DeleteDoc: DeleteDoc,
            DeleteDocItem: DeleteDocItem,
            GetAccessPath: GetAccessPath,
            GetAccessPathIfWork: GetAccessPathIfWork,
            ErrorCode: ErrorCode,
            //unsused-GetTreeVirtualized: GetTreeVirtualized,
            UnchangedChildrenList: UnchangedChildrenList,
            CopyItem: CopyItem,
            RenameItem: RenameItem,
            GetMaxFilenameLength: GetMaxFilenameLength,
            CollisionCheck: CollisionCheck,
            GetSelectionTreeXml: GetSelectionTreeXml,
            GetLocalAccessPath: GetLocalAccessPath,
            CopyToCurrent: CopyToCurrent,
            GetVersionsForCopyToCurrent: GetVersionsForCopyToCurrent,
            AddAuditTrailForOpenFile: AddAuditTrailForOpenFile,
            VaultFileCheck: VaultFileCheck,
            RequiredFieldsEnabled: undefined,
            FilterForDelete: FilterForDelete
        };
        return service;

        function ExToErr(selectionItem, selectionList, response) {
            var msg = "";
            if(selectionItem != null && selectionList != null && response != null) {
                // If we get a proper response packet.
                if (response.data != null) {
                    msg = response.data.Message;
                }
                else if (response.responseJSON != null && response.responseJSON.ExceptionMessage != null && response.responseJSON.ExceptionMessage.length > 0) {
                    msg = response.responseJSON.ExceptionMessage
                }
                else if (response.responseJSON != null && response.responseJSON.Message != null && response.responseJSON.Message.length > 0) {
                    msg = response.responseJSON.Message
                }
                else {
                    msg = "Unknown Exception.";
                }
            }
            selectionItem.ecEnumStr = loginService.resourceStrings["EXCEPTION"];
            selectionItem.errStr = msg;
            if (selectionItem.detailedInfo != null)
                selectionItem.errLibStr = selectionItem.detailedInfo.libName;
            selectionList.list.push(selectionItem);
        }

        function ShowEx(response) {
            var msg = "";
            if (response != null) {
                // If we get a proper response packet.
                if (response.data != null) {
                    msg = response.data.Message;
                }
                else if (response.responseJSON != null && response.responseJSON.ExceptionMessage != null && response.responseJSON.ExceptionMessage.length > 0) {
                    msg = response.responseJSON.ExceptionMessage
                }
                else if (response.responseJSON != null && response.responseJSON.Message != null && response.responseJSON.Message.length > 0) {
                    msg = response.responseJSON.Message
                }
                else {
                    msg = "Unknown Exception.";
                }
            }
            $rootScope.msgBoxShow(msg, loginService.resourceStrings["EXCEPTION"], 3, true);
        }

        function CheckOutVaultCheck(libId, fileId, alreadyCheckedArray) {
            var deferred = $q.defer();

            var bAlreadyChecked = false;
            if (alreadyCheckedArray != null) {
                angular.forEach(alreadyCheckedArray, function (thisLibId) {
                    if (thisLibId == libId)
                        bAlreadyChecked = true;
                });
            }
            if (bAlreadyChecked) {
                var response = {};
                response.data = null;
                deferred.resolve(response);
            }
            else {
                var request = $http({
                    url: '../Synergis.WebApi/api/SelectionCommand/CheckOutVaultCheck',
                    method: 'PUT',
                    data: JSON.stringify(fileId),
                    headers: {
                        "Content-Type": "application/json"
                    }
                });
                request.then(function (response) {
                    alreadyCheckedArray.push(libId);
                    deferred.resolve(response);
                }, function (response) {
                    deferred.reject(response);
                });
            }

            return deferred.promise;
        }

        // Call the command with a Selection List.
        function CheckOutItem(fileId, workAreaId) {
            var checkOutItemObject = { fileId: fileId, workAreaId: workAreaId };
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/checkoutitem',
                method: 'PUT',
                data: JSON.stringify(checkOutItemObject),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        // Call the command with a Selection List.
        function PreCheckInItem(fileId, libId) {
            var preCheckInItemObject = { fileId: fileId, libId: libId };
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/precheckinitem',
                method: 'PUT',
                data: JSON.stringify(preCheckInItemObject),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        // Call the command with a Selection List.
        function CheckInItem(fileId, libId, assignToId, undoCheckOut, keepOut, createVersion, stagingFileOperationModel) {
            var checkInItemObject = { fileId: fileId, libId: libId, assignToId: assignToId, undoCheckOut: undoCheckOut, keepOut: keepOut, createVersion: createVersion, stagingFileOperationModel: stagingFileOperationModel };
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/checkinitem',
                method: 'PUT',
                data: JSON.stringify(checkInItemObject),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        function getFileTypes() {
            var deferred = $q.defer();
            var request = $http.get('../Synergis.WebApi/api/FileTypes');
            request.then(function (response) {
                deferred.resolve(response.data);
            }, function (response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function newDoc(slx) {
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/New',
                method: 'PUT',
                data: JSON.stringify(slx),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        // Call the command with a Selection List.
        function ReleaseCheckOut(slx) {
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/ReleaseCheckOut',
                method: 'PUT',
                data: JSON.stringify(slx),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        // Call the command with a Selection List.
        function AcquireCheckOutSources(filename) {
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/AcquireCheckOutSources',
                method: 'PUT',
                data: JSON.stringify(filename),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        // Call the command with a Selection List.
        function AcquireCheckOut(slx) {
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/AcquireCheckOut',
                method: 'PUT',
                data: JSON.stringify(slx),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        // Call the command with a fileId.
        function GetVersionsForCopyToCurrent(fileId) {
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/CopyToCurrentSources',
                method: 'PUT',
                data: JSON.stringify(fileId),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }


        // Call the command with a Selection List.
        function CopyToCurrent(slx) {
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/CopyToCurrent',
                method: 'PUT',
                data: JSON.stringify(slx),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        // Call the command with a Selection List.
        function DeleteDoc(slx) {
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/Delete',
                method: 'PUT',
                data: JSON.stringify(slx),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        // Call the command with a Selection List.
        function DeleteDocItem(tableNumber, fileId, majRev, minRev) {
            //var deleteDocItemObject = { tableNumber: tableNumber, fileId: fileId, majRev: majRev, minRev: minRev, bDeleteFileToo: bDeleteFileToo };
            var selectionItem = { tableNumber: tableNumber, fileId: fileId, majRev: majRev, minRev: minRev };
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/deletedocitem',
                method: 'PUT',
                data: JSON.stringify(selectionItem),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        //
        function GetAccessPath(tableNumber, fileId, majRev, minRev) {
            var deferred = $q.defer();
            var url = '../Synergis.WebApi/api/Document/AccessPath/';
            url = url.concat(tableNumber + '/' + fileId + '/' + majRev + '/' + minRev + '/');
            var request = $http.get(url);
            request.then(function (response) {
                deferred.resolve(response.data);
            }, function (response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        //
        function GetAccessPathIfWork(tableNumber, fileId, majRev, minRev) {
            var deferred = $q.defer();
            var url = '../Synergis.WebApi/api/Document/AccessPathIfWork/';
            url = url.concat(tableNumber + '/' + fileId + '/' + majRev + '/' + minRev + '/');
            var request = $http.get(url);
            request.then(function (response) {
                deferred.resolve(response.data);
            }, function (response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        //
        function ErrorCode(selectionItem, ec) {
            var deferred = $q.defer();
            var url = '../Synergis.WebApi/api/SelectionCommand/ErrorCode/';
            url = url.concat(ec + '/');
            var request = $http({
                url: url,
                method: 'PUT',
                data: JSON.stringify(selectionItem),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        ////
        //function GetTreeVirtualized(tableNumber, fileId, majRev, minRev, localVirtualLibraryPath) {
        //    var deferred = $q.defer();
        //    var url = '../Synergis.WebApi/api/Document/GetTreeVirtualized/';
        //    url = url.concat(tableNumber + '/' + fileId + '/' + majRev + '/' + minRev + '/');
        //    var request = $http({
        //        url: url,
        //        method: 'PUT',
        //        data: JSON.stringify(localVirtualLibraryPath),
        //        headers: {
        //            "Content-Type": "application/json"
        //        }
        //    });
        //    return request;
        //}

        function UnchangedChildrenList(selectionList) {
            var unchangedChildrenRequest = { slx: selectionList}
            var deferred = $q.defer();
            var url = '../Synergis.WebApi/api/SelectionCommand/UnchangedChildrenList/';
            //url = url.concat(tableNumber + '/' + fileId + '/' + majRev + '/' + minRev + '/');
            var request = $http({
                url: url,
                method: 'PUT',
                data: JSON.stringify(unchangedChildrenRequest),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        // Call the command with a Selection List.
        function CopyItem(filename, tableNumber, fileId, majRev, minRev, workAreaId, bCopyDataCard, newName, slx) {
            var commandParams = { eWorkAreaId: workAreaId, ebCopyDataCard: bCopyDataCard, eNewName: newName};
            var selectionItem = { filename: filename, tableNumber: tableNumber, fileId: fileId, majRev: majRev, minRev: minRev, commandParams: commandParams };
            var copyItemObject = { selectionItem: selectionItem, slxContextSet: slx };
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/copyitem',
                method: 'PUT',
                data: JSON.stringify(copyItemObject),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        // Call the command with a Selection List.
        function RenameItem(filename, tableNumber, fileId, majRev, minRev, newName) {
            var commandParams = { eNewName: newName };
            var selectionItem = { filename: filename, tableNumber: tableNumber, fileId: fileId, majRev: majRev, minRev: minRev, commandParams: commandParams };
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/renameitem',
                method: 'PUT',
                data: JSON.stringify(selectionItem),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        function GetMaxFilenameLength() {
            var deferred = $q.defer();
            var url = '../Synergis.WebApi/api/SelectionCommand/MaxFilenameLength/';
            var request = $http.get(url);
            request.then(function (response) {
                deferred.resolve(response.data);
            }, function (response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        // Call the command with a Selection List.
        function CollisionCheck(commandNumber, fileId, newName, newDocOutFromLibId, destinationWorkAreaId, bExistsLocally) {
            var collisionCheckRequest = {
                commandNumber: commandNumber, fileId: fileId, newName: newName, newDocOutFromLibId: newDocOutFromLibId,
                destinationWorkAreaId: destinationWorkAreaId, bExistsLocally: bExistsLocally
            };
            var request = $http({
                url: '../Synergis.WebApi/api/SelectionCommand/CollisionCheck',
                method: 'PUT',
                data: JSON.stringify(collisionCheckRequest),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        function GetSelectionTreeXml(commandNumber, slx) {
            var url = '../Synergis.WebApi/api/SelectionCommand/SelectionTreeXml';
            url = url + "/" + commandNumber;
            var request = $http({
                url: url,
                method: 'PUT',
                data: JSON.stringify(slx),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        function GetLocalAccessPath(tableNumber, fileId, majRev, minRev, localVirtualLibraryPath) {
            var url = '../Synergis.WebApi/api/Document/LocalAccessPath';
            url = url + "/" + tableNumber + "/" + fileId + "/" + majRev + "/" + minRev;
            var request = $http({
                url: url,
                method: 'PUT',
                data: JSON.stringify(localVirtualLibraryPath),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        function AddAuditTrailForOpenFile(fileId, majRev, minRev) {
            var CHN_LAUNCH__LAUNCH_DEFAULT = 66;
            var auditTrailDefinition = { auditTrailCommandNumber: CHN_LAUNCH__LAUNCH_DEFAULT, fileId: fileId, majRev: majRev, minRev: minRev};
            var request = $http({
                url: '../Synergis.WebApi/api/AuditTrail/Add',
                method: 'POST',
                data: JSON.stringify(auditTrailDefinition),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return request;
        }

        function VaultFileCheck(commandNumber, fileId) {
            var deferred = $q.defer();

            var url = '../Synergis.WebApi/api/SelectionCommand/VaultFileCheck/' +  commandNumber + "/" + fileId;

            var request = $http.get(url);

            request.then(function (response) {
                deferred.resolve(response);
            }, function (response) {
                deferred.reject(response);
            });

            return deferred.promise;
        }

        function FilterForDelete(slx) {
            var deferred = $q.defer();
            var url = '../Synergis.WebApi/api/SelectionCommand/FilterForDelete';
            var request = $http({
                url: url,
                method: 'PUT',
                data: JSON.stringify(slx),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            request.then(function (response) {
                deferred.resolve(response);
            }, function (response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }


    }
})();